<template lang="html">
  <div>
    <div class="label node-move" style="padding: 0 0 0 10px;">
      <span style="width: 100%;">Text</span>
      <button type="button" class="btn-flat btn-icon" @click="addText()" style="margin-right: 10px;"><i class="icon-add"></i></button>
      <AssetSelector v-model="node.asset" />
    </div>
    <div>
      <div v-for="(text, index) in node.texts" :key="index" class="node-text">
        <textarea v-model="node.texts[index]" placeholder="text..." class="form-input" rows="4"></textarea>
        <button v-if="index > 0" type="button" class="btn-flat btn-icon" @click="removeText(index)"><i class="icon-delete"></i></button>
      </div>
    </div>
    <div>
      <div class="label node-move">
        <span>Choices</span>
        <button type="button" class="btn-flat btn-icon" @click="addChoice()"><i class="icon-add"></i></button>
      </div>
      <div v-for="(choice, index) in node.choices" :key="index" class="node-choice">
        <input type="text" v-model="choice.text" placeholder="choice" class="form-input" />
        <button type="button" class="btn-flat btn-icon" @click="removeChoice(index)"><i class="icon-delete"></i></button>
        <div class="node-connector" :class="{'active': choice.to}" :data-index="index" :data-to="choice.to"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetSelector from '@/assets/components/dialog/AssetSelector.vue'

export default {
	props: ['node'],
	// emits: ['update:modelValue'],
  components: {
    AssetSelector
  },
	methods: {
    addText() {
      this.node.texts.push('');
    },
    removeText(index) {
      this.node.texts.splice(index, 1);
    },
    addChoice() {
      this.node.choices.push({
        text: '',
        to: null
      });
    },
    removeChoice(index) {
      this.node.choices.splice(index, 1);
    }
	}
}
</script>

<style lang="css" scoped>
.node-text {
  position: relative;
}
.node-text textarea {
  display: block;
  font-family: monospace;
  resize: none;
  border-width: 0 0 1px 0;
}
.node-text button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
}
.node-choice {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.node-choice input {
  font-family: monospace;
  border: none;
}
.node-choice button {
  margin: 0 2px;
  padding: 3px;
}
.node-choice .node-connector {
  margin-left: 2px;
  margin-right: -9px;
  border-radius: 50%;
  border: 3px solid #34434b;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  background-color: #1f282d;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  /* border-left-color: transparent; */
  /* border-top-color: transparent; */
  transform: rotate(-45deg);
}
.node-choice .node-connector.active::before {
  content: '';
  position: absolute;
  background-color: #ffa800;
  border-radius: 50%;
  inset: 1px;
}
.node-box.selected .node-choice .node-connector {
  border-right-color: rgba(255, 168, 0, 0.8);
  border-bottom-color: rgba(255, 168, 0, 0.8);
}
</style>
